// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uO-z","hovered":"vO-z","hoverImage":"wO-z","mainImage":"xO-z","imageNoBackground":"yO-z","fullSizeImage":"zO-z"};